import { ReportBrand, ReportUpcs } from '@/api/receive';
import { QtyKeys } from '../types';

export const calc = (
  items: ReportUpcs[] & ReportBrand[],
  key: QtyKeys
): number =>
  (items || []).reduce((acc, item) => acc + (item[key] || 0), 0) || 0;
